var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 144,
    viewBox: "0 0 135 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.45 0C77.93 12.23 70.67 24.13 61.83 33.29C56.3 42.27 49.83 51.52 43.34 59.37C29.66 53.95 14.14 59.1 0 59.71C8.09 64.51 14.82 70.05 23.18 74.41C26.07 77.25 36.77 79.92 35.43 84.39C30.13 101.13 23.52 118.74 16.93 134.8C21.2 128.6 30.38 126.87 36.24 122.06C41.66 115.36 50.94 112.62 56.1 106.3C70.8 113.06 77.58 130.97 86.16 143.64C81.39 137.15 98.68 101.72 101.14 92.93C107.38 92.64 113.71 92.99 119.8 90.9C124.86 89.74 129.47 92.78 134.86 90.36C119.18 80.75 107.84 64.81 90.61 57.91C81.65 57.07 82.6 51.08 82.42 44.16C79.76 33.38 77.49 23.57 79.03 12.19",
    fill: "#D34E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3599ebec466d5a5349487285fa29d436.svg";
export { ForwardRef as ReactComponent };